<template>
    <div class="ourStoryBG">
        <el-row>
            <el-backtop target=".ourStoryBG" style="background-color:#ffefef;width:50px;height:50px;"></el-backtop>
            <el-col :span="12" :offset="6">
                <el-card v-for="item in story" :key="index" class="storyCard storyHidden">
            <el-row>
                <el-col class="storyText">
                    <span class="storyTitle">
                        {{ item.title }}
                    </span>
                </el-col>
            </el-row>

            <el-divider content-position="left">
                <i class="el-icon-date storyDate"></i>
                <span class="storyDate">
                    <mark v-if="item.special === true">
                        {{ item.date }}
                        <span style="color:#a82e36">
                            ❤
                        </span>
                    </mark>
                    <span v-if="item.special === false">
                        {{ item.date }}
                    </span>
                </span>
            </el-divider>

            <el-row style="display:flex;margin-bottom:20px;">
                <el-col :span="24" class="storyContent">
                    {{ item.message }}
                </el-col>
            </el-row>

            <el-row :gutter="10">
                <el-col :span="6" class="storyPic" v-for="pic in item.pic" style="margin-bottom:10px;">
                    <el-image style="width: 11.5vw; height: 11.5vw;display:inline-block;" :src="pic" fit="cover"
                        :preview-src-list="item.pic" lazy></el-image>
                </el-col>
            </el-row>
            
        </el-card>
            </el-col>
        </el-row>
        
        <el-row class="storyHidden">
                <el-col>
                    <el-image src="https://img.codesocean.top/image/1666766937925" style="width:5vw;"></el-image>
                </el-col>
            </el-row>
        <div style="height:500px;"></div>

        <div class="storyBottom">
            知道你还没看够，下面没东西啦
        </div>
    </div>
</template>

<script>

export default {
    name: 'ourStory',
    created() {

    },
    data() {
        return {
            story: [
                {
                    title: '小兔诞生',
                    date: '2001年9月4日',
                    message: '在很久很久以前，美丽的一天，一个小小的可爱兔来到了这个世界上。',
                    pic: [
                        'https://img.codesocean.top/image/1666710042894'
                    ],
                    special: false,
                },
                {
                    title: '小鱼诞生',
                    date: '2002年5月4日',
                    message: '在小兔诞生以后的八个月，又是美丽的一天，一个小小的可爱鱼也来到了这个世界上。',
                    pic: [
                        'https://img.codesocean.top/image/1666710011164'
                    ],
                    special: false,
                },
                {
                    title: '小兔和小鱼一起上学了',
                    date: '2018年9月1日',
                    message: '上了高二，小兔和小鱼分到了同一个班里，小鱼第一眼看到小兔就喜欢上了，觉得她好可爱好可爱，是可爱兔兔，从那以后，小鱼就开始追求小兔了。',
                    pic: [
                        'https://img.codesocean.top/image/1666712542333'
                    ],
                    special: false,
                },
                {
                    title: '小鱼追求小兔',
                    date: '2018年9月和10月',
                    message: '小鱼一心追求小兔，小兔因为之前听到别的坏蛋说小鱼的坏话，所以对小鱼还有戒备。在这期间，小鱼经常给小兔写化学笔记，还和小兔去吃好吃的。',
                    pic: [
                        'https://img.codesocean.top/image/1666712781024',
                        'https://img.codesocean.top/image/1666710010692'
                    ],
                    special: false,
                },
                {
                    title: '小鱼和小兔在一起了',
                    date: '2018年11月10日',
                    message: '经历了两个月的追求后，小兔最终看到了小鱼的真心，知道小鱼不是坏蛋，而是一个心地善良的可爱小鱼，于是小鱼如愿以偿地和小兔在一起了。',
                    pic: [
                        'https://img.codesocean.top/image/1666710106154'
                    ],
                    special: true,
                },
                {
                    title: '小鱼给小兔送礼物',
                    date: '2018年到现在',
                    message: '小鱼给小兔送了好多好多的礼物，有花花，有口红，有小鱼自己做的小手工，有小鱼写的小程序',
                    pic: [
                        'https://img.codesocean.top/image/1666710144537',
                        'https://img.codesocean.top/image/1666710133489',
                        'https://img.codesocean.top/image/1666711591192',
                        'https://img.codesocean.top/image/1666711647301',
                        'https://img.codesocean.top/image/1666711699892',
                        'https://img.codesocean.top/image/1666711711843'
                    ],
                    special: false,
                },
                {
                    title: '小兔给小鱼送礼物',
                    date: '2018年到现在',
                    message: '小兔也给小鱼送了好多好多的礼物，有好吃的，有鞋鞋，有鼠标，有耳机，还有小兔自己亲手织的围巾',
                    pic: [
                        'https://img.codesocean.top/image/1666711666182',
                        'https://img.codesocean.top/image/1666711688734'
                    ],
                    special: false,
                },
                {
                    title: '小鱼带小兔吃吃喝喝',
                    date: '2018年到现在',
                    message: '小鱼发誓要带小兔吃遍全世界美食，因为小鱼和小兔都是小吃货，喜欢吃吃吃。小鱼也经常给小兔做好吃的，小兔也很喜欢小鱼做的好吃的东西。',
                    pic: [
                        'https://img.codesocean.top/image/1666710044808',
                        'https://img.codesocean.top/image/1666710124375',
                        'https://img.codesocean.top/image/1666710114833',
                        'https://img.codesocean.top/image/1666710166165',
                        'https://img.codesocean.top/image/1666710148212',
                        'https://img.codesocean.top/image/1666711643785',
                    ],
                    special: false,
                },
                {
                    title: '小鱼带小兔吃吃喝喝',
                    date: '2018年到现在',
                    message: '照片太多，一次放完会卡卡的',
                    pic: [
                        'https://img.codesocean.top/image/1666711669199',
                        'https://img.codesocean.top/image/1666711677718',
                        'https://img.codesocean.top/image/1666711715013',
                        'https://img.codesocean.top/image/1666711728614',
                        'https://img.codesocean.top/image/1666711720594',
                        'https://img.codesocean.top/image/1666711736359'
                    ],
                    special: false,
                },
                {
                    title: '小鱼带小兔吃吃喝喝',
                    date: '2018年到现在',
                    message: '照片太多，一次放完会卡卡的',
                    pic: [
                        'https://img.codesocean.top/image/1666711747061',
                        'https://img.codesocean.top/image/1666711747847',
                        'https://img.codesocean.top/image/1666711754338',
                        'https://img.codesocean.top/image/1666711788588',
                        'https://img.codesocean.top/image/1666711796790',
                        'https://img.codesocean.top/image/1666711797876'
                    ],
                    special: false,
                },
                {
                    title: '小鱼和小兔一起上学',
                    date: '2018年9月到2020年7月',
                    message: '小鱼和小兔有一个很好的班主任，他叫莫主任，莫主任教导小鱼和小兔好好学习，好好生活，要做对社会有用的人，做一个平凡的人，成一些不平凡的事。',
                    pic: [
                        'https://img.codesocean.top/image/1666711573331',
                        'https://img.codesocean.top/image/1666711621214',
                        'https://img.codesocean.top/image/1666711644920'
                    ],
                    special: false,
                },
                {
                    title: '小鱼17岁咯',
                    date: '2019年5月4日',
                    message: '这一天，可爱小鱼17岁咯，小鱼过了和小兔在一起以后的第一个生日，收到了小兔送的生日礼物。',
                    pic: [
                        'https://img.codesocean.top/image/1666711546327',
                        'https://img.codesocean.top/image/1666715859529'
                    ],
                    special: false,
                },
                {
                    title: '小兔18岁咯',
                    date: '2019年9月4日',
                    message: '这一天，可爱小兔18岁咯，小兔过了和小鱼在一起以后的第一个生日，收到了小鱼送的生日礼物。',
                    pic: [
                        'https://img.codesocean.top/image/1666716004336',
                        'https://img.codesocean.top/image/1666716219777'
                    ],
                    special: false,
                },
                {
                    title: '小鱼18岁咯',
                    date: '2020年5月4日',
                    message: '这一天，可爱小鱼18岁咯，小鱼和小兔还有好多好朋友一起过生日，吃蛋糕。',
                    pic: [
                        'https://img.codesocean.top/image/1666711589596',
                        'https://img.codesocean.top/image/1666711591713'
                    ],
                    special: false,
                },
                {
                    title: '成人礼咯',
                    date: '2020年6月不记得几号',
                    message: '这一天，小兔和小鱼的学校办了成人礼，小鱼和小兔一起穿的帅帅的，美美的，然后拍照照。但是鱼鱼那个时候变坏坏了，伤了小兔的心心，\
                    后面小鱼知道自己的坏蛋蛋行为是错误的了，就好好地反思了自己，知道不能辜负乖乖兔的爱，不能伤了乖乖兔的心，也不能对乖乖兔不负责任，\
                    就改过自新了，从那以后小鱼比以前更爱、更珍惜小兔了。',
                    pic: [
                        'https://img.codesocean.top/image/1666716374400',
                        'https://img.codesocean.top/image/1666716240287',
                        'https://img.codesocean.top/image/1666716322537',
                        'https://img.codesocean.top/image/1666716332846'
                    ],
                    special: false,
                },
                {
                    title: '小鱼上报纸咯',
                    date: '2020年7月不记得几号',
                    message: '这一天，小鱼因为在签名墙上写了一手好字然后被人拍了下来，莫名其妙就上了南宁日报咯。',
                    pic: [
                        'https://img.codesocean.top/image/1666711699549'
                    ],
                    special: false,
                },
                {
                    title: '小兔19岁咯',
                    date: '2020年9月4日',
                    message: '这一天，可爱小兔19岁咯，小兔和小鱼还有几个好朋友一起吃饭过生日，小鱼还给小兔编辫子。',
                    pic: [
                        'https://img.codesocean.top/image/1666716760210',
                        'https://img.codesocean.top/image/1666716720631'
                    ],
                    special: false,
                },
                {
                    title: '啊哦，小鱼和小兔异地恋咯',
                    date: '2020年9月1日以后',
                    message: '小鱼和小兔上大学了，但是因为没有合适的城市让小鱼和小兔都可以去，所以小鱼和小兔异地恋了，虽然不是很远，但是因为有疫情，所以还是不能经常见面，讨厌哦。\
                    小鱼和小兔只能每天对着手机相互看对方。',
                    pic: [
                        'https://img.codesocean.top/image/1666717061803',
                        'https://img.codesocean.top/image/1666717089184'
                    ],
                    special: false,
                },
                {
                    title: '小鱼和小兔见面啦！',
                    date: '见了好多次喔',
                    message: '虽然有疫情，虽然也忙忙，但是有时放假的时候小鱼和小兔还是可以见面的喔，小鱼和小兔在一起玩玩，吃吃，看电视，好开心好开心。',
                    pic: [
                        'https://img.codesocean.top/image/1666711644167',
                        'https://img.codesocean.top/image/1666711647909',
                        'https://img.codesocean.top/image/1666711674453',
                        'https://img.codesocean.top/image/1666711732839',
                        'https://img.codesocean.top/image/1666711728976',
                        'https://img.codesocean.top/image/1666711719192'
                    ],
                    special: false,
                },
                {
                    title: '放假回家啦！',
                    date: '回了好多次喔',
                    message: '放假啦，回家以后小鱼和小兔迫不及待地去玩，去开车车，去吃吃家里的好吃的，去转来转去，开心开心开心。',
                    pic: [

                        'https://img.codesocean.top/image/1666711732923',
                        'https://img.codesocean.top/image/1666711727155',
                        'https://img.codesocean.top/image/1666711742429',
                        'https://img.codesocean.top/image/1666711886534',
                        'https://img.codesocean.top/image/1666711927799',
                        'https://img.codesocean.top/image/1666711673809'
                    ],
                    special: false,
                },
                {
                    title: '放假回家啦！',
                    date: '回了好多次喔',
                    message: '照片太多，一次放完会卡卡的。',
                    pic: [
                        'https://img.codesocean.top/image/1666711616612',
                        'https://img.codesocean.top/image/1666711649346',
                        'https://img.codesocean.top/image/1666711659063',
                        'https://img.codesocean.top/image/1666711714739',
                        'https://img.codesocean.top/image/1666711714741'
                    ],
                    special: false,
                },
                {
                    title: '小鱼和小兔见亲戚',
                    date: '见了好多次喔',
                    message: '小鱼和小兔谈了好久的恋爱，也见过好多次好多次亲戚，更不用说见家长了，小鱼的亲戚喜欢小兔，小兔的亲戚也喜欢小鱼，以后小鱼和小兔会幸幸福福地组建小家庭滴。',
                    pic: [
                        'https://img.codesocean.top/image/1666711727155',
                        'https://img.codesocean.top/image/1666717582759',
                        'https://img.codesocean.top/image/1666717585704',
                        'https://img.codesocean.top/image/1666978548520'
                    ],
                    special: false,
                },
                {
                    title: '小鱼和小兔的一堆癫鬼好朋友',
                    date: '这帮癫鬼一直都有在身边',
                    message: '小鱼和小兔有一帮癫鬼朋友，虽然不经常能聚在一起，但是聚在一起的时候都很癫',
                    pic: [
                        'https://img.codesocean.top/image/1666978545018',
                        'https://img.codesocean.top/image/1666978625690',
                        'https://img.codesocean.top/image/1666978642473'
                    ],
                    special: false,
                },
                {
                    title: '小鱼和小兔看日出日落',
                    date: '看了好多次喔',
                    message: '小鱼喜欢和小兔一起看日出、看日落、看彩虹、看晚霞，小鱼觉得，小兔就是老天给小鱼最好的礼物。',
                    pic: [
                        'https://img.codesocean.top/image/1666710095300',
                        'https://img.codesocean.top/image/1666711486269',
                        'https://img.codesocean.top/image/1666711642958',
                        'https://img.codesocean.top/image/1666711650602',
                        'https://img.codesocean.top/image/1666711725169'
                    ],
                    special: false,
                },
                {
                    title: '小鱼和小兔的爱情故事',
                    date: '2018年11月10日-永永远远',
                    message: '人生有限，不过几十年，但是小鱼和小兔会永永远远拥有他们的甜蜜爱情，他们的爱情故事也会一直一直书写下去到永远。',
                    pic: [
                        'https://img.codesocean.top/image/1666718311077'
                    ],
                    special: true,
                },
            ]
        }
    },
    mounted() {
        if (this.$userInfo.$userLimit === '') {
            this.$message({
                message: '不要乱来哦',
                type: 'warning'
            });
            this.$router.push('/noZone');
        }
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('storyShow');
                }
            });
        })
        const hiddenElements = document.querySelectorAll('.storyHidden');
        hiddenElements.forEach((el) => observer.observe(el));
    },
    methods: {

    }
}
</script>


<style scoped lang="scss">
mark {
    background-color: transparent;
    color: inherit;
    background-image: linear-gradient(#b83e46b5, #b83e46b5);
    background-repeat: no-repeat;
    background-size: 100% 30%;
    background-position: 0 100%;
}

.storyDate {
    font-family: "HMOS_Regular";
    font-weight: 600;
    font-size: 2vh;
}

.storyContent {
    display: inline-block;
    text-indent: 30px;
    align-self: center;
    text-align: left;
}

.storyTitle {
    font-family: "HMOS_Regular";
    font-size: 3vh;
}

.storyPic {
    height: auto;
    display: inline-block;
    align-self: center;
}

.storyText {
    height: 100%;
    text-align: left;
}

.storyCard {
    display: inline-block;
    margin: 0 auto;
    width: 100%;
    margin-top: 10px;
    height: auto;
    margin-bottom: 5px;
    text-align: center;
}

.ourStoryBG {
    /* background-color:#bfa; */
    width: 100%;
    height: 100%;
    text-align: center;
    overflow: auto;
}

.storyBottom {
    text-align: center;
    color: #333;
    height: 100px;
    font-family: "HMOS_Regular"
}

.storyHidden {
    // filter: blur(5px);
    transform: translateY(50%);
    opacity: 0;
    transition: all 1000ms;
}

.storyShow {
    // filter: blur(0);
    transform: translateY(0);
    opacity: 1;
}

::-webkit-scrollbar {
    display: none;
}
</style>